/**
 * Takes a canvas context, width and height of the canvas and clears the canvas
 * returns the cleared context
 * @param context
 * @param width
 * @param height
 * @returns {*}
 */
export function clearCanvasContext(context, width = 1024, height = 1024) {
    context.clearRect(0, 0, width, height);
    return context;
}

/**
 * Adds an image to context
 * @param context
 * @param base64
 * @param width
 * @param height
 * @param x
 * @param y
 * @returns {Promise}
 */
export function addImageToContext(context, base64, width, height, x = 0, y = 0) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = base64;
        image.onload = () => {
            context.drawImage(image, x, y, width, height);
            resolve(context);
        };
    });
}
